export const environment = {
  production: true,
  _baseUrl : 'https://www.akillibinalar.com.tr/portal/api',
  fileUploadPath : '/portal/upload',
  clientVersion: '1.0.3'
};
